import { render, staticRenderFns } from "./ShiftSignatureCard.vue?vue&type=template&id=53fcb68a&scoped=true&"
import script from "./ShiftSignatureCard.vue?vue&type=script&lang=js&"
export * from "./ShiftSignatureCard.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSignatureCard.vue?vue&type=style&index=0&id=53fcb68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fcb68a",
  null
  
)

export default component.exports